import { useFlag } from '../services/launchDarkly';
import { useStores } from '../stores/useStores';

// Single rule for every Crown Sports entry point (lobby widget, Crown Lounge tile): the feature flags
// plus a sport event returned for the user, whatever its state (upcoming, live or reward waiting).
export function useIsCrownSportVisible(): boolean {
  const { sportEventsStore } = useStores();
  const monetizationEventsFeature = useFlag('monetization_events_enabled', true);
  const crownSportsFeature = useFlag('crown_sports_feature', false);

  return monetizationEventsFeature && crownSportsFeature && !!sportEventsStore.sportEvent;
}
